<div class="margin-button-pane">
    <button mat-flat-button
            color="cancel"
            data-qa-id="duplicateMarginButton"
            class="margin-button-font-color"
            [matTooltipDisabled]="marginExists$ | async"
            matTooltip="Please save before duplicating"
            [disabled]="(marginExists$ | async) === false"
            (click)="duplicateMargin()">DUPLICATE
    </button>
    <button mat-flat-button
            color="primary"
            data-qa-id="saveMarginButton"
            (click)="saveMargin()"
            [disabled]="(isSaveEnabled$ | async) === false || (formDisabled$ | async)"
            [matTooltip]="saveTooltip$ | async">SAVE
    </button>
    <button *ngIf="isRecruiting$ | async"
            mat-flat-button
            color="primary"
            data-qa-id="viewPayPackageButton"
            (click)="openPayEmailDetails()">VIEW PAY PACKAGE
    </button>
    <button *ngIf="isRecruiting$ | async"
            mat-flat-button
            color="primary"
            data-qa-id="reviewAndSendButtonWithTooltip"
            (click)="contractRequest()"
            [disabled]="reviewAndSendButtonDisabled$ | async"
            [matTooltip]="reviewSendTooltip$ | async">REVIEW + SEND
    </button>
    <button *ngIf="isNurseContracting$ | async"
            mat-flat-button
            color="primary"
            [disabled]="(marginExists$ | async) === false"
            [ngClass]="{'hidden': isPipelined$ | async}"
            data-qa-id="pipelineMarginButton"
            (click)="pipelineMargin()">PIPELINE
    </button>
    <button *ngIf="(isNurseContracting$ | async) && (isPipelined$ | async)"
            mat-flat-button
            color="primary"
            data-qa-id="contractModButton"
            (click)="contractMod()">CONTRACT MOD
    </button>
</div>
